import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StakeholderResponseComponent } from './components/stakeholder-response/stakeholder-response.component';

const routes: Routes = [{ path: '', component: StakeholderResponseComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StakeholderResponseRoutingModule {}
